<script>
  import { createEventDispatcher } from 'svelte';
  import Checkbox from './Checkbox.svelte';

  const dispatch = createEventDispatcher();

  export let items = {};

  export let showAllItems = false;
  export let selectedItems = new Set();
  export let itemsToShow = 8;

  function handleCheckboxChange(/** @type any */ event, /** @type string */ idItem) {
    if (event.target.checked) {
      selectedItems.add(idItem);
    } else {
      selectedItems.delete(idItem);
    }

    dispatch('filtersChange');
  }
</script>

<div class="columns">
  {#each Object.entries(items).slice(0, showAllItems ? Object.entries(items).length : itemsToShow) as [id, name]}
    <div>
      <Checkbox
        {id}
        {name}
        checked={selectedItems.has(id)}
        onCheckboxChange={handleCheckboxChange}
      />
    </div>
  {/each}
</div>

<style>
  .columns {
    column-count: 2;
    column-gap: 1rem;
  }

  .columns > div {
    break-inside: avoid;
  }

  @media (max-width: 767px) {
    .columns {
      column-count: 1;
    }
  }
</style>
